
import { Vue, Component } from "vue-property-decorator";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
import { List } from "lodash";
import { ListDataSource } from "@/data/List/ListDataSource";

@Component
export default class Home extends Vue {
  dataSource: ObjectDataSource = new ObjectDataSource({
    id: +this.$route.params.id,
    config: {},
    className: "AIModel",
  });


  requestDataSource:ListDataSource = new ListDataSource({
    className: "AIModelRequest",
    config: {
      pageIndex: 1,
      pageSize: 100,
      filter:JSON.stringify([
        {
          fieldName: "aiModelId",
          fieldValue: this.dataSource.id,
        },
      ]),
    },
  });

  createItemModel = {
    aiModelId: this.dataSource.id,
    caption: "",
  }

  get caption() {
    return this.dataSource.model?.caption || "ИИ модель";
  }

  get breadcrumbs() {
    return [
      {
        text: "Главная",
        to: "/",
      },
      {
        text: "ИИ модели",
        to: "/manage/ai-models/",
        exact: true,
      },
      {
        text: this.caption, 
        disabled: true,
      },
    ];
  }
}
